import React from 'react';
import ScaleAngelsLogo from '../assets/scale_angels_logo.png';

const Overview = ({ companyCount }) => {
  return (
    <div className="overview">
      <img
        className="overview-logo"
        src={ScaleAngelsLogo}
        alt="Scale Angels Logo"
      />
      <div className="overview-text">
        <h2>About Us</h2>
        <p>We are a micro fund comprised of Scale AI employees and alumni, writing checks into seed rounds of AI companies either started by Scale Alumni or within our broader network of founders. Our partners are spread across every major AI startup, providing access to a vast network of AI experts.</p>
        <dl className="stats">
          <div>
            <dt>Check size</dt>
            <dd>$25–100k</dd>
          </div>
          <div>
            <dt>Portfolio companies</dt>
            <dd>{companyCount}</dd>
          </div>
          <div>
            <dt>Stage</dt>
            <dd>Seed</dd>
          </div>
        </dl>
        <p className="disclaimer"><i>We are not officially affiliated with Scale AI.</i></p>
      </div>
    </div>
  );
};

export default Overview;
